export const siteConfig = {
  name: '成人动漫精选推荐',
  tagline: '探索成人动漫的世界，发现属于你的精彩',
  description: '成人动漫精选推荐，汇聚高质量成人动漫作品推荐、类型解析与观看指南。无论你是成人动漫新手还是资深爱好者，都能找到适合自己的内容分类与精选推荐，助你快速发现优质成人动漫资源。',
  keywords: '成人动漫,成人动漫推荐,成人动漫网站,成人动漫类型,成人动漫排行榜,高分成人动漫,成人动漫在线观看',
  url: 'https://www.example.com',
  ogImage: 'https://readdy.ai/api/search-image?query=Stylized%20anime%20art%20style%20illustration%20with%20warm%20vermillion%20and%20golden%20tones%2C%20dramatic%20cinematic%20lighting%2C%20abstract%20Japanese%20ink%20wash%20background%2C%20artistic%20composition%2C%20elegant%20and%20refined%20atmosphere%2C%20mature%20aesthetic%2C%20subtle%20texture%20overlay&width=1200&height=630&seq=og-image-2026&orientation=landscape',
};

export const categories = [
  { id: 'story', name: '剧情向', icon: 'ri-movie-2-line', description: '情节深刻、人物塑造丰满的作品推荐' },
  { id: 'fantasy', name: '奇幻冒险', icon: 'ri-compass-3-line', description: '异世界、魔法与冒险的精彩旅程' },
  { id: 'scifi', name: '科幻未来', icon: 'ri-rocket-line', description: '未来科技与人性思考的碰撞' },
  { id: 'romance', name: '都市情感', icon: 'ri-heart-line', description: '现代都市中的情感与羁绊' },
  { id: 'mystery', name: '悬疑推理', icon: 'ri-search-eye-line', description: '烧脑推理与悬疑氛围的极致体验' },
  { id: 'historical', name: '历史古风', icon: 'ri-ancient-gate-line', description: '历史背景下的壮阔叙事与美学' },
];

export const featuredAnime = [
  {
    id: 1,
    title: '暗夜吟游者',
    category: 'story',
    rating: 9.2,
    image: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20anime%20art%20style%20illustration%2C%20mysterious%20hooded%20figure%20in%20moonlight%2C%20atmospheric%20with%20fog%20and%20ancient%20ruins%2C%20vermillion%20accent%20colors%2C%20cinematic%20composition%2C%20mature%20aesthetic%2C%20Japanese%20illustration%20style%2C%20dramatic%20shadows%2C%20painterly%20texture&width=600&height=840&seq=anime-feat-01&orientation=portrait',
    description: '在黑暗与光明交织的世界中，一位背负宿命的吟游诗人踏上了寻找真相的旅程。',
    tags: ['剧情深度', '暗黑奇幻', '高分推荐'],
    year: 2025,
  },
  {
    id: 2,
    title: '星河边境',
    category: 'scifi',
    rating: 9.5,
    image: 'https://readdy.ai/api/search-image?query=Sci%20fi%20anime%20art%20style%2C%20futuristic%20space%20explorer%20with%20neon%20accents%2C%20vast%20galaxy%20background%2C%20starships%20in%20distance%2C%20warm%20golden%20and%20crimson%20color%20palette%2C%20cinematic%20lighting%2C%20mature%20sci%20fi%20aesthetic%2C%20detailed%20mechanical%20design&width=600&height=840&seq=anime-feat-02&orientation=portrait',
    description: '人类星际殖民时代的史诗级科幻巨作，探讨人性与科技的终极命题。',
    tags: ['硬核科幻', '太空歌剧', '年度最佳'],
    year: 2025,
  },
  {
    id: 3,
    title: '樱庭记',
    category: 'romance',
    rating: 8.9,
    image: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20art%20style%2C%20cherry%20blossom%20garden%20scene%2C%20elegant%20couple%20silhouette%20under%20blooming%20trees%2C%20soft%20warm%20lighting%2C%20rose%20gold%20and%20coral%20tones%2C%20atmospheric%20dusk%20setting%2C%20mature%20romantic%20aesthetic%2C%20Japanese%20illustration%20style&width=600&height=840&seq=anime-feat-03&orientation=portrait',
    description: '在樱花纷飞的京都庭院，两位成年人之间细腻而克制的感情故事。',
    tags: ['都市情感', '细腻描写', '治愈系'],
    year: 2024,
  },
  {
    id: 4,
    title: '雾都迷案',
    category: 'mystery',
    rating: 9.0,
    image: 'https://readdy.ai/api/search-image?query=Mystery%20anime%20art%20style%2C%20foggy%20Victorian%20city%20street%2C%20detective%20figure%20with%20trench%20coat%2C%20gas%20lamps%20and%20shadows%2C%20warm%20amber%20and%20deep%20crimson%20lighting%2C%20noir%20atmosphere%2C%20mature%20detective%20aesthetic%2C%20Japanese%20illustration&width=600&height=840&seq=anime-feat-04&orientation=portrait',
    description: '维多利亚时代雾都中，一系列诡异案件串联起的惊天阴谋。',
    tags: ['悬疑推理', '时代剧', '烧脑神作'],
    year: 2024,
  },
  {
    id: 5,
    title: '剑风传说：默示录',
    category: 'fantasy',
    rating: 9.3,
    image: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20anime%20art%2C%20warrior%20with%20massive%20sword%20in%20desolate%20battlefield%2C%20dark%20stormy%20sky%2C%20dramatic%20lighting%20with%20crimson%20sunset%2C%20medieval%20fantasy%20setting%2C%20mature%20dark%20fantasy%20aesthetic%2C%20Japanese%20illustration%20style&width=600&height=840&seq=anime-feat-05&orientation=portrait',
    description: '黑暗奇幻的巅峰之作，描绘了一个充满绝望与希望并存的残酷世界。',
    tags: ['黑暗奇幻', '史诗战斗', '成人向'],
    year: 2023,
  },
  {
    id: 6,
    title: '千年之约',
    category: 'historical',
    rating: 9.1,
    image: 'https://readdy.ai/api/search-image?query=Historical%20anime%20art%20style%2C%20ancient%20Chinese%20dynasty%20palace%20scene%2C%20elegant%20figure%20in%20traditional%20robes%2C%20moonlit%20garden%20with%20lanterns%2C%20warm%20golden%20and%20jade%20green%20tones%2C%20atmospheric%20historical%20setting%2C%20mature%20aesthetic&width=600&height=840&seq=anime-feat-06&orientation=portrait',
    description: '跨越千年的宿命轮回，在历史洪流中追寻永恒之爱的壮丽诗篇。',
    tags: ['历史古风', '轮回转世', '视觉盛宴'],
    year: 2024,
  },
];

export const topRankings = [
  { rank: 1, title: '星河边境', rating: 9.5, category: '科幻未来', hot: '128万热度' },
  { rank: 2, title: '剑风传说：默示录', rating: 9.3, category: '奇幻冒险', hot: '115万热度' },
  { rank: 3, title: '暗夜吟游者', rating: 9.2, category: '剧情向', hot: '98万热度' },
  { rank: 4, title: '千年之约', rating: 9.1, category: '历史古风', hot: '87万热度' },
  { rank: 5, title: '雾都迷案', rating: 9.0, category: '悬疑推理', hot: '76万热度' },
  { rank: 6, title: '樱庭记', rating: 8.9, category: '都市情感', hot: '69万热度' },
  { rank: 7, title: '深渊回响', rating: 8.8, category: '剧情向', hot: '63万热度' },
  { rank: 8, title: '机械之心', rating: 8.7, category: '科幻未来', hot: '58万热度' },
  { rank: 9, title: '月下奇谭', rating: 8.6, category: '奇幻冒险', hot: '52万热度' },
  { rank: 10, title: '东京暗影', rating: 8.5, category: '悬疑推理', hot: '47万热度' },
];

export const articles = [
  {
    id: 1,
    title: '2025年必看成人动漫TOP10推荐——从经典到新番一网打尽',
    excerpt: '2025年涌现了大量优秀的成人动漫作品，从深度剧情到精美作画，本文将为你盘点今年最值得观看的十部成人动漫。',
    category: '推荐榜单',
    date: '2025-07-28',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20collage%20of%20top%2010%20mature%20anime%20recommendations%2C%20cinematic%20montage%20with%20dramatic%20lighting%2C%20warm%20vermillion%20and%20golden%20color%20palette%2C%20artistic%20composition%2C%20Japanese%20illustration%20style%2C%20elegant%20layout&width=800&height=500&seq=article-01&orientation=landscape',
    content: '',
  },
  {
    id: 2,
    title: '成人动漫类型全解析：从剧情向到科幻，找到你的专属风格',
    excerpt: '成人动漫的类型丰富多样，不同题材有着截然不同的叙事风格和受众群体。本文将带你深入了解各大类型的特点。',
    category: '类型解析',
    date: '2025-07-20',
    readTime: '12分钟',
    image: 'https://readdy.ai/api/search-image?query=Anime%20genre%20classification%20visual%20guide%2C%20different%20anime%20style%20panels%20arranged%20artistically%2C%20from%20fantasy%20to%20sci%20fi%20to%20romance%2C%20warm%20color%20palette%2C%20Japanese%20illustration%2C%20clean%20modern%20layout&width=800&height=500&seq=article-02&orientation=landscape',
    content: '',
  },
  {
    id: 3,
    title: '高分成人动漫推荐：豆瓣9.0以上的必看神作盘点',
    excerpt: '在成人动漫的浩瀚海洋中，哪些作品真正称得上神作？本文精选豆瓣评分9.0以上的高分成人动漫。',
    category: '高分推荐',
    date: '2025-07-15',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=High%20rated%20anime%20masterpiece%20recommendation%20visual%2C%20award%20winning%20anime%20art%20collage%2C%20golden%20stars%20and%20ratings%2C%20warm%20amber%20and%20crimson%20tones%2C%20premium%20Japanese%20illustration%20style%2C%20elegant%20cinematic%20composition&width=800&height=500&seq=article-03&orientation=landscape',
    content: '',
  },
  {
    id: 4,
    title: '成人动漫新手入门指南：从零开始探索成人动漫世界',
    excerpt: '如果你是成人动漫的新手，不知道从哪里开始看起，这篇入门指南将手把手带你走进成人动漫的精彩世界。',
    category: '入门指南',
    date: '2025-07-08',
    readTime: '15分钟',
    image: 'https://readdy.ai/api/search-image?query=Beginners%20guide%20to%20mature%20anime%20visual%2C%20welcoming%20anime%20style%20illustration%2C%20warm%20inviting%20atmosphere%2C%20bookshelf%20with%20anime%20volumes%2C%20soft%20golden%20lighting%2C%20Japanese%20art%20style%2C%20clean%20cozy%20composition&width=800&height=500&seq=article-04&orientation=landscape',
    content: '',
  },
  {
    id: 5,
    title: '成人动漫观看平台大盘点：正版高清资源哪里找',
    excerpt: '在哪里能观看到高清正版的成人动漫资源？本文为你梳理了国内外主流的成人动漫观看平台及其特点。',
    category: '资源指南',
    date: '2025-06-30',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Streaming%20platforms%20for%20anime%20visual%2C%20modern%20digital%20devices%20displaying%20anime%20content%2C%20warm%20ambient%20lighting%2C%20clean%20tech%20aesthetic%2C%20Japanese%20illustration%20style%2C%20minimal%20composition&width=800&height=500&seq=article-05&orientation=landscape',
    content: '',
  },
  {
    id: 6,
    title: '成人动漫中的女性角色塑造：从符号到深度的进化之路',
    excerpt: '成人动漫中女性角色的刻画经历了怎样的演变？本文深度分析近十年来女性角色塑造的进步与突破。',
    category: '深度分析',
    date: '2025-06-22',
    readTime: '11分钟',
    image: 'https://readdy.ai/api/search-image?query=Anime%20character%20design%20evolution%20visual%2C%20strong%20female%20characters%20in%20mature%20anime%2C%20artistic%20character%20illustration%2C%20warm%20rose%20and%20coral%20tones%2C%20Japanese%20illustration%20style%2C%20elegant%20composition&width=800&height=500&seq=article-06&orientation=landscape',
    content: '',
  },
];

export const articleContents: Record<number, { sections: { heading: string; paragraphs: string[] }[]; tags: string[] }> = {
  1: {
    tags: ['TOP10', '2025年', '必看推荐', '新番', '经典', '盘点'],
    sections: [
      {
        heading: '引言',
        paragraphs: [
          '2025年是成人动漫产业蓬勃发展的一年，大量高质量作品如雨后春笋般涌现。从深度剧情到精美作画，从严肃社会议题到人性探讨，今年的成人动漫展现了前所未有的创作活力。',
          '本文将为你盘点2025年最值得观看的十部成人动漫作品，无论你是资深爱好者还是刚刚入门的新手，这份榜单都将成为你探索成人动漫世界的绝佳指南。',
        ],
      },
      {
        heading: '1. 星河边境 — 太空歌剧的巅峰之作',
        paragraphs: [
          '《星河边境》以23世纪人类星际殖民时代为背景，讲述了人类在浩瀚宇宙中与其他文明接触的故事。这部作品的叙事格局宏大，视觉呈现极具冲击力，被誉为"太空歌剧的新里程碑"。',
          '该作品不仅仅是一部科幻动漫，更是一场关于人性、文明与存在的哲学探索。制作团队耗时四年打磨每一个细节，从飞船设计到外星文明的语言体系，都经过严谨的考据与创意设计。',
        ],
      },
      {
        heading: '2. 暗夜吟游者 — 黑暗奇幻的叙事典范',
        paragraphs: [
          '《暗夜吟游者》以一个被黑暗笼罩的中世纪奇幻世界为舞台，主角——一位失去记忆的吟游诗人——在追寻身份真相的过程中，逐渐揭开了一个横跨数百年的惊天阴谋。',
          '作品在叙事技法上大胆创新，采用多线叙事与闪回交错的手法，将过去与现在的故事巧妙编织。画面风格偏向暗黑写实，配乐由知名作曲家操刀，营造出令人沉浸的奇幻氛围。',
        ],
      },
      {
        heading: '3. 千年之约 — 穿越时空的史诗爱情',
        paragraphs: [
          '《千年之约》的故事跨越千年时光，讲述了在不同时代中反复相遇却又被命运分离的两位主角。作品以中国古典美学为基调，融合了日式动画的精湛技艺。',
          '画面表现达到艺术品级别，每一帧都可以截图作为壁纸。剧情在爱情主线之外，还融入了大量的历史文化元素和对命运的哲学思考。',
        ],
      },
      {
        heading: '4. 机械之心 — 赛博朋克的人性叩问',
        paragraphs: [
          '《机械之心》设定在一个高度发达的赛博朋克世界中，探讨了当人类能够将意识上传至机械体时，"人"的定义究竟为何。这部作品以冷峻的视觉风格和深刻的人文关怀赢得了广泛的赞誉。',
          '作品中充满了对科技伦理的深度思考，剧情紧凑且环环相扣，每一集都留下了令人深思的悬念。',
        ],
      },
      {
        heading: '5. 樱庭记 — 成熟爱情的细腻描摹',
        paragraphs: [
          '《樱庭记》不同于常见的青春校园恋爱题材，聚焦于两个成熟成年人之间的感情故事。作品以京都为舞台，通过精致的画面和细腻的心理描写，展现了成年人感情世界的复杂与美好。',
          '这部作品的节奏舒缓但绝不拖沓，每一段对白都经过精心雕琢，角色的每一个微表情都传递着丰富的情感信息。',
        ],
      },
      {
        heading: '6. 雾都迷案 — 维多利亚时代的悬疑盛宴',
        paragraphs: [
          '《雾都迷案》将舞台搬到了维多利亚时代的伦敦，以一系列离奇案件为线索，串联起一个跨越阶级与权力的巨大阴谋。',
          '作品在悬疑氛围的营造上堪称教科书级别，每一个案件都设计精巧，推理过程逻辑严谨，配合上浓郁的蒸汽朋克美学，呈现出一场视觉与智力的双重盛宴。',
        ],
      },
      {
        heading: '7. 深渊回响 — 心理惊悚的类型突破',
        paragraphs: [
          '《深渊回响》探讨了人类内心最深处的恐惧与欲望。主角是一位心理咨询师，在接手一位特殊患者后，逐渐陷入了一系列无法用理性解释的事件之中。',
          '该作品在心理描写方面达到了成人动漫的新高度，通过巧妙的视觉隐喻和音效设计，将角色的内心世界具象化呈现。',
        ],
      },
      {
        heading: '8. 月下奇谭 — 东方奇幻的新经典',
        paragraphs: [
          '《月下奇谭》以中国古代神话传说为蓝本，创造了一个充满妖怪、神仙和凡人的奇幻世界。作品在传统文化的基础上大胆创新，赋予了古老传说全新的生命力。',
          '画风融合了水墨画与现代动画技法，呈现出独特的视觉美学。剧情在轻松幽默与深沉感人之间自如切换。',
        ],
      },
      {
        heading: '9. 东京暗影 — 都市动作的标杆之作',
        paragraphs: [
          '《东京暗影》讲述了一群生活在东京暗面的特殊能力者之间的故事。动作场面的设计令人叹为观止，每一场战斗都经过精心编排，既有视觉冲击力又不失逻辑性。',
          '作品在动作之外也不乏对现代都市社会问题的关注，将娱乐性与社会意义完美结合。',
        ],
      },
      {
        heading: '10. 冰封纪元 — 末世生存的壮丽诗篇',
        paragraphs: [
          '《冰封纪元》设定在地球进入新冰河时代后的世界，幸存的人类在极端环境中艰难求生。作品在视觉上呈现出一片冰冷而壮美的末日景象。',
          '剧情聚焦于人性在极端环境下的光辉与黑暗，每一个角色的选择都令人深思。',
        ],
      },
      {
        heading: '总结',
        paragraphs: [
          '2025年的成人动漫作品在题材、叙事和视觉表现上都达到了新的高度。无论你喜欢哪种类型，都能在这一年的作品中找到适合自己的精彩之作。希望这份榜单能为你的观看旅程提供有价值的参考。',
        ],
      },
    ],
  },
  2: {
    tags: ['类型解析', '剧情向', '科幻', '奇幻', '悬疑', '情感'],
    sections: [
      {
        heading: '引言',
        paragraphs: [
          '成人动漫的类型丰富多样，每一种类型都有其独特的叙事风格、视觉美学和受众群体。了解这些类型的特点，有助于你更精准地找到符合自己口味的作品。',
        ],
      },
      {
        heading: '剧情向 — 深度叙事的力量',
        paragraphs: [
          '剧情向成人动漫以复杂的情节架构和深刻的人物塑造为核心卖点。这类作品通常具有以下特点：多层次的故事线索、精心设计的人物弧光、以及对严肃社会议题的深入探讨。',
          '代表作品包括《暗夜吟游者》、《深渊回响》等。适合喜欢思考、追求叙事深度的观众。',
        ],
      },
      {
        heading: '奇幻冒险 — 想象力的无限边界',
        paragraphs: [
          '奇幻冒险类是成人动漫中最受欢迎的类型之一。从《剑风传说：默示录》的黑暗奇幻到《月下奇谭》的东方神话，奇幻冒险作品以丰富的世界观和精彩的冒险故事吸引着大量观众。',
          '这类作品的核心魅力在于其构建的独特世界观，以及主角在冒险过程中的成长与蜕变。',
        ],
      },
      {
        heading: '科幻未来 — 技术与人文的交汇',
        paragraphs: [
          '科幻类成人动漫以未来科技为背景，探讨技术进步对人类社会的深远影响。从太空歌剧到赛博朋克，从人工智能到基因改造，科幻动漫涵盖了极为广泛的主题。',
        ],
      },
      {
        heading: '都市情感 — 现实世界的动人故事',
        paragraphs: [
          '都市情感类成人动漫聚焦于现代都市中的人际关系与情感纠葛。这类作品以真实细腻的情感描写见长，常常能够引起观众的强烈共鸣。',
        ],
      },
      {
        heading: '悬疑推理 — 智力的极致挑战',
        paragraphs: [
          '悬疑推理类成人动漫以精巧的谜题设计和紧张的氛围营造著称。从侦探推理到心理惊悚，这类作品要求观众全程保持高度专注。',
        ],
      },
      {
        heading: '历史古风 — 时光中的美学与叙事',
        paragraphs: [
          '历史古风类成人动漫以真实历史或架空古代世界为背景，融合了历史文化元素与精致的古典美学。这类作品往往具有宏大的叙事格局和视觉上的独特魅力。',
        ],
      },
    ],
  },
  3: {
    tags: ['高分推荐', '豆瓣9.0', '神作', '必看', '评分'],
    sections: [
      {
        heading: '引言',
        paragraphs: [
          '在成人动漫的广阔海洋中，真正称得上"神作"的作品屈指可数。本文以豆瓣评分为主要参考，精选了评分在9.0以上的高分成人动漫作品。',
        ],
      },
      {
        heading: '评分标准说明',
        paragraphs: [
          '本文的评分数据来源于豆瓣，综合了评分人数与评分值两个维度。只有同时满足评分9.0以上且评分人数超过一定基数的作品才被纳入推荐范围。',
        ],
      },
      {
        heading: '星河边境 — 9.5分',
        paragraphs: [
          '作为2025年的现象级作品，《星河边境》以精湛的制作水准和深度的故事内容征服了大量观众。其9.5的高分实至名归。',
        ],
      },
      {
        heading: '剑风传说：默示录 — 9.3分',
        paragraphs: [
          '《剑风传说：默示录》延续了系列的优良传统，在黑暗奇幻的基础上加入了更多的人性思考，获得了观众和评论界的一致好评。',
        ],
      },
      {
        heading: '暗夜吟游者 — 9.2分',
        paragraphs: [
          '这部作品以其独特的叙事风格和精美的画面赢得了9.2的高分，被许多评论家誉为"年度最佳剧情向成人动漫"。',
        ],
      },
      {
        heading: '总结',
        paragraphs: [
          '高分作品之所以能获得如此高的评价，往往不仅仅是因为其制作精良，更因为它们能够触动观众的内心，引发深层次的思考。',
        ],
      },
    ],
  },
  4: {
    tags: ['入门指南', '新手', '入门', '观看顺序', '推荐'],
    sections: [
      {
        heading: '欢迎来到成人动漫的世界',
        paragraphs: [
          '成人动漫是一个丰富多彩的艺术形式，它不同于一般的少年向动漫，通常包含更深刻的主题、更复杂的角色塑造以及更成熟的表现手法。',
          '如果你刚开始接触成人动漫，面对琳琅满目的作品可能会感到无所适从。别担心，这篇指南将帮助你从零开始，系统地了解并享受成人动漫的魅力。',
        ],
      },
      {
        heading: '第一步：了解你的偏好',
        paragraphs: [
          '在开始观看之前，先问问自己喜欢什么类型的故事：是科幻、奇幻，还是现实题材？喜欢动作场面还是心理描写？明确自己的偏好，可以大大提高找到心仪作品的效率。',
        ],
      },
      {
        heading: '第二步：从入门级作品开始',
        paragraphs: [
          '建议新手从叙事节奏相对舒缓、世界观设定不过于复杂的作品入手。例如《樱庭记》这类都市情感作品，或《千年之约》这样具有文化亲和力的历史古风作品。',
        ],
      },
      {
        heading: '第三步：逐步拓展观看范围',
        paragraphs: [
          '当你对成人动漫的叙事风格有了一定了解后，可以逐步尝试更多元的类型和风格。不要局限于单一类型，广泛涉猎才能发现更多惊喜。',
        ],
      },
      {
        heading: '第四步：参与社区讨论',
        paragraphs: [
          '加入成人动漫相关的讨论社区，与其他爱好者交流看法，是提升观看体验的重要方式。在交流中你会发现许多自己之前没有注意到的细节和解读角度。',
        ],
      },
    ],
  },
  5: {
    tags: ['观看平台', '正版', '高清', '资源', '平台对比'],
    sections: [
      {
        heading: '引言',
        paragraphs: [
          '随着成人动漫市场的不断扩大，越来越多的平台开始提供成人动漫的观看服务。选择一个合适的平台，对观看体验至关重要。',
        ],
      },
      {
        heading: '国内主流平台',
        paragraphs: [
          '国内各大视频平台近年来在成人动漫领域投入了大量资源，引进了众多高质量的正版成人动漫作品。这些平台的优势在于语言无障碍和支付便利。',
        ],
      },
      {
        heading: '国际平台选择',
        paragraphs: [
          '国际主流动漫平台通常拥有更丰富的片库和更早的上线时间。对于追求第一时间观看新番的观众来说，国际平台是更好的选择。',
        ],
      },
      {
        heading: '选择建议',
        paragraphs: [
          '我们建议优先选择正版平台支持创作者，同时根据自己对画质、字幕、更新速度等方面的需求来做出选择。',
        ],
      },
    ],
  },
  6: {
    tags: ['女性角色', '角色塑造', '深度分析', '进化', '性别议题'],
    sections: [
      {
        heading: '引言',
        paragraphs: [
          '成人动漫中女性角色的塑造经历了从刻板符号到立体人物的漫长进化过程。本文将从历史发展的角度，深入分析这一转变背后的原因与意义。',
        ],
      },
      {
        heading: '早期的刻板印象',
        paragraphs: [
          '成人动漫发展初期，女性角色往往被简化为服务于男性叙事的工具性角色，缺乏独立的人格和成长弧线。',
        ],
      },
      {
        heading: '转型期的探索',
        paragraphs: [
          '随着女性创作者的增多和观众审美的提升，成人动漫开始出现更多具有复杂性格和独立故事线的女性角色。',
        ],
      },
      {
        heading: '当代的多元化呈现',
        paragraphs: [
          '如今的成人动漫中，女性角色的塑造已经达到了前所未有的丰富程度。从战士到科学家，从统治者到艺术家，女性角色在各种类型作品中都展现出了多元化的面貌。',
        ],
      },
      {
        heading: '展望未来',
        paragraphs: [
          '虽然已经取得了显著进步，但成人动漫中女性角色的塑造仍有提升空间。我们期待看到更多真实、立体、有力量的女性角色出现在未来的作品中。',
        ],
      },
    ],
  },
};

export const faqs = [
  {
    question: '成人动漫和普通动漫有什么区别？',
    answer: '成人动漫通常面向18岁以上的观众群体，在主题深度、叙事复杂度、视觉表现以及涉及的社会议题等方面更加成熟。成人动漫不仅仅是"限制级内容"的代名词，更多指的是作品在思想深度和艺术表现上的成熟度。',
  },
  {
    question: '如何选择适合自己的成人动漫？',
    answer: '建议根据自己的兴趣偏好来选择类型：喜欢深度思考的可以选择剧情向或科幻类；喜欢视觉冲击的可以选择奇幻冒险类；喜欢情感细腻的可以选择都市情感类。你可以在我们的分类页面中浏览不同类型，找到最适合自己的作品。',
  },
  {
    question: '成人动漫的评分可信吗？',
    answer: '我们网站的评分综合了多个平台的用户评价，包括豆瓣、MyAnimeList等国内外主流评分平台。虽然单一平台的评分可能存在偏差，但综合多个平台的评分能够提供更全面客观的参考。',
  },
  {
    question: '本网站的推荐多久更新一次？',
    answer: '我们的编辑团队每周都会更新推荐内容，确保你能够及时了解到最新的高质量成人动漫作品。遇到新番季期间，更新频率会相应提高。',
  },
  {
    question: '可以在哪里观看推荐的成人动漫？',
    answer: '我们推荐通过各大正版视频平台观看，这样既能保证观看质量，也能支持创作者。具体平台信息可以参考我们网站上的"成人动漫观看平台大盘点"文章。',
  },
  {
    question: '这个网站是完全免费的吗？',
    answer: '是的，成人动漫精选推荐是完全免费的资源导航网站。我们不收取任何费用，也不提供付费会员服务。我们的目标是为成人动漫爱好者提供一个高质量的推荐和导航平台。',
  },
];

export const reviews = [
  {
    name: '动漫爱好者小王',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20male%20character%20portrait%20avatar%2C%20warm%20friendly%20expression%2C%20simple%20clean%20background%2C%20Japanese%20illustration%20style%2C%20soft%20lighting&width=100&height=100&seq=avatar-01&orientation=squarish',
    rating: 5,
    comment: '这个网站的推荐质量真的很高！在这里找到了好几部之前完全没听说过但是非常好看的成人动漫，分类也很清晰。',
    date: '2025-07-15',
  },
  {
    name: '资深动漫迷小李',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20female%20character%20portrait%20avatar%2C%20cool%20confident%20expression%2C%20simple%20clean%20background%2C%20Japanese%20illustration%20style%2C%20soft%20lighting&width=100&height=100&seq=avatar-02&orientation=squarish',
    rating: 5,
    comment: '作为一个看了十几年动漫的老粉，这个网站的推荐和解析文章真的很专业，类型解析文章写得特别透彻。',
    date: '2025-06-28',
  },
  {
    name: '刚入门的小张',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20character%20portrait%20avatar%2C%20excited%20happy%20expression%2C%20simple%20clean%20background%2C%20Japanese%20illustration%20style%2C%20soft%20lighting&width=100&height=100&seq=avatar-03&orientation=squarish',
    rating: 5,
    comment: '刚接触成人动漫不知道从哪开始看，这个网站的入门指南简直是我的救星！推荐的作品每一部都很好看。',
    date: '2025-06-10',
  },
];

export const categoryAllAnime = [
  { id: 101, title: '暗夜吟游者', category: 'story', rating: 9.2, year: 2025, image: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20anime%20cover%20art%2C%20mysterious%20wanderer%20in%20cloak%2C%20moonlit%20ancient%20city%2C%20vermillion%20accents%2C%20cinematic%20composition%2C%20Japanese%20illustration&width=400&height=560&seq=cat-story-01&orientation=portrait', description: '在黑暗与光明交织的世界中追寻真相的史诗旅程。' },
  { id: 102, title: '深渊回响', category: 'story', rating: 8.8, year: 2024, image: 'https://readdy.ai/api/search-image?query=Psychological%20thriller%20anime%20art%2C%20dark%20ocean%20depths%2C%20silhouette%20falling%2C%20deep%20blue%20and%20crimson%2C%20atmospheric%2C%20Japanese%20illustration&width=400&height=560&seq=cat-story-02&orientation=portrait', description: '深入人类心灵最黑暗角落的心理惊悚杰作。' },
  { id: 103, title: '黄昏之境', category: 'story', rating: 8.6, year: 2023, image: 'https://readdy.ai/api/search-image?query=Twilight%20anime%20scene%2C%20lonely%20figure%20at%20train%20station%2C%20warm%20golden%20hour%20light%2C%20nostalgic%20atmosphere%2C%20Japanese%20illustration&width=400&height=560&seq=cat-story-03&orientation=portrait', description: '在黄昏时分相遇与别离的人生百态。' },
  { id: 201, title: '剑风传说：默示录', category: 'fantasy', rating: 9.3, year: 2023, image: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20warrior%20anime%20art%2C%20massive%20sword%2C%20stormy%20battlefield%2C%20crimson%20sky%2C%20epic%20scale%2C%20Japanese%20illustration&width=400&height=560&seq=cat-fantasy-01&orientation=portrait', description: '黑暗奇幻的巅峰，绝望中绽放希望之花。' },
  { id: 202, title: '月下奇谭', category: 'fantasy', rating: 8.6, year: 2024, image: 'https://readdy.ai/api/search-image?query=Eastern%20fantasy%20anime%20art%2C%20moonlit%20bamboo%20forest%2C%20mythical%20creatures%2C%20ink%20wash%20style%2C%20Japanese%20illustration&width=400&height=560&seq=cat-fantasy-02&orientation=portrait', description: '东方神话与现代动画美学的完美融合。' },
  { id: 203, title: '龙裔纪元', category: 'fantasy', rating: 8.4, year: 2025, image: 'https://readdy.ai/api/search-image?query=Dragon%20rider%20anime%20art%2C%20epic%20sky%20battle%2C%20fantasy%20landscape%2C%20warm%20golden%20light%2C%20Japanese%20illustration&width=400&height=560&seq=cat-fantasy-03&orientation=portrait', description: '人与龙之间的羁绊，书写天空中的传奇。' },
  { id: 301, title: '星河边境', category: 'scifi', rating: 9.5, year: 2025, image: 'https://readdy.ai/api/search-image?query=Space%20opera%20anime%20art%2C%20futuristic%20spaceship%2C%20nebula%20background%2C%20golden%20and%20crimson%20tones%2C%20Japanese%20illustration&width=400&height=560&seq=cat-scifi-01&orientation=portrait', description: '人类星际殖民时代的科幻史诗。' },
  { id: 302, title: '机械之心', category: 'scifi', rating: 8.7, year: 2024, image: 'https://readdy.ai/api/search-image?query=Cyberpunk%20anime%20art%2C%20android%20character%2C%20neon%20city%2C%20mechanical%20design%2C%20warm%20lighting%2C%20Japanese%20illustration&width=400&height=560&seq=cat-scifi-02&orientation=portrait', description: '赛博朋克世界中关于人性的终极追问。' },
  { id: 303, title: '冰封纪元', category: 'scifi', rating: 8.3, year: 2025, image: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20ice%20age%20anime%20art%2C%20frozen%20cityscape%2C%20survivor%20figure%2C%20cold%20blue%20and%20warm%20light%2C%20Japanese%20illustration&width=400&height=560&seq=cat-scifi-03&orientation=portrait', description: '冰封世界的壮丽末世生存诗篇。' },
  { id: 401, title: '樱庭记', category: 'romance', rating: 8.9, year: 2024, image: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20scene%20in%20Kyoto%20garden%2C%20cherry%20blossoms%2C%20elegant%20adult%20couple%2C%20warm%20rose%20light%2C%20Japanese%20illustration&width=400&height=560&seq=cat-romance-01&orientation=portrait', description: '京都庭院中成年人之间的细腻情感故事。' },
  { id: 402, title: '午夜咖啡馆', category: 'romance', rating: 8.2, year: 2023, image: 'https://readdy.ai/api/search-image?query=Night%20cafe%20anime%20scene%2C%20warm%20interior%2C%20two%20people%20talking%2C%20intimate%20atmosphere%2C%20Japanese%20illustration&width=400&height=560&seq=cat-romance-02&orientation=portrait', description: '午夜咖啡馆里上演的一段温柔邂逅。' },
  { id: 403, title: '雨中的约定', category: 'romance', rating: 8.5, year: 2025, image: 'https://readdy.ai/api/search-image?query=Rainy%20day%20anime%20scene%2C%20two%20figures%20under%20umbrella%2C%20city%20street%2C%20soft%20warm%20lighting%2C%20Japanese%20illustration&width=400&height=560&seq=cat-romance-03&orientation=portrait', description: '雨中重逢的约定，温暖了整座城市。' },
  { id: 501, title: '雾都迷案', category: 'mystery', rating: 9.0, year: 2024, image: 'https://readdy.ai/api/search-image?query=Victorian%20detective%20anime%20art%2C%20foggy%20London%20street%2C%20mysterious%20figure%2C%20amber%20gaslight%2C%20Japanese%20illustration&width=400&height=560&seq=cat-mystery-01&orientation=portrait', description: '维多利亚时代雾都中的惊天阴谋。' },
  { id: 502, title: '东京暗影', category: 'mystery', rating: 8.5, year: 2024, image: 'https://readdy.ai/api/search-image?query=Modern%20Tokyo%20noir%20anime%20art%2C%20dark%20alley%2C%20neon%20reflections%2C%20mysterious%20atmosphere%2C%20Japanese%20illustration&width=400&height=560&seq=cat-mystery-02&orientation=portrait', description: '东京暗面的守护者与罪恶的较量。' },
  { id: 503, title: '第七封印', category: 'mystery', rating: 8.7, year: 2025, image: 'https://readdy.ai/api/search-image?query=Occult%20mystery%20anime%20art%2C%20ancient%20symbols%2C%20candlelit%20room%2C%20dark%20atmosphere%2C%20Japanese%20illustration&width=400&height=560&seq=cat-mystery-03&orientation=portrait', description: '古老封印被解开，一场跨越世纪的谜局。' },
  { id: 601, title: '千年之约', category: 'historical', rating: 9.1, year: 2024, image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20dynasty%20anime%20art%2C%20elegant%20figure%20in%20traditional%20robes%2C%20palace%20garden%2C%20golden%20light%2C%20Japanese%20illustration&width=400&height=560&seq=cat-hist-01&orientation=portrait', description: '千年轮回中的不朽爱情史诗。' },
  { id: 602, title: '战国之花', category: 'historical', rating: 8.4, year: 2023, image: 'https://readdy.ai/api/search-image?query=Sengoku%20period%20anime%20art%2C%20female%20warrior%2C%20battlefield%2C%20dramatic%20sunset%2C%20Japanese%20illustration&width=400&height=560&seq=cat-hist-02&orientation=portrait', description: '战国乱世中绽放的巾帼之花。' },
  { id: 603, title: '长安夜未央', category: 'historical', rating: 8.8, year: 2025, image: 'https://readdy.ai/api/search-image?query=Tang%20dynasty%20Changan%20anime%20art%2C%20ancient%20capital%20at%20night%2C%20lanterns%2C%20elegant%20atmosphere%2C%20Japanese%20illustration&width=400&height=560&seq=cat-hist-03&orientation=portrait', description: '大唐长安的繁华夜色与家国情怀。' },
];